// Packages
import { useTimer } from 'react-timer-hook'

// Components
import { Flex, Text } from 'yard-utilities/components'

// Styles
import styles from './CountdownTimer.module.sass'

const CountdownTimer = () => {
  const { seconds, minutes } = useTimer({
    expiryTimestamp: new Date(Date.now() + 900000)
  })

  const getTime = (time: number) => {
    if (time === 0) {
      return [0, 0]
    } else if (time.toString().split('').length === 1) {
      return [0, time]
    } else {
      return time.toString().split('')
    }
  }

  return (
    <Flex columnGap={{ sm: 2 }}>
      <Flex flexDirection="column" center>
        <Text variant="title-2" textColor="white" className={styles.time}>
          {getTime(minutes)[0]}
          {getTime(minutes)[1]}
        </Text>
        <Text variant="body-5" textColor="white">
          min
        </Text>
      </Flex>

      <Text variant="title-2" textColor="white" fontWeight={400}>
        :
      </Text>

      <Flex flexDirection="column" center>
        <Text variant="title-2" textColor="white" className={styles.time}>
          {getTime(seconds)[0]}
          {getTime(seconds)[1]}
        </Text>
        <Text variant="body-5" textColor="white">
          sec
        </Text>
      </Flex>
    </Flex>
  )
}

export default CountdownTimer
